<!-- Modal Bootstrap -->
<div class="modal fade" id="modalEsqueceuSenha" tabindex="-1" aria-labelledby="modalEsqueceuSenhaLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 rounded-4 shadow-lg">

      <!-- Formulário -->
      <ng-container *ngIf="!submitted">

        <div class="modal-header border-0 pb-0 px-4 pt-4">
          <div class="modal-icon me-3">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          </div>
          <h5 class="modal-title fw-bold" id="modalEsqueceuSenhaLabel">Esqueceu a senha?</h5>
          <button type="button" class="btn-close ms-auto" (click)="close()" aria-label="Fechar"></button>
        </div>

        <div class="modal-body px-4 pt-2 pb-0">
          <p class="text-muted" style="font-size:14px;">
            Informe seu login e enviaremos as instruções para redefinir sua senha.
          </p>

          <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

            <div class="mb-3">
              <label for="forgot-login" class="form-label fw-medium" style="font-size:13px;">Login</label>
              <input
                id="forgot-login"
                type="text"
                class="form-control"
                [class.is-invalid]="loginControl?.invalid && loginControl?.touched"
                formControlName="login"
                placeholder="Seu login"
                autocomplete="username"
              />
              <div class="invalid-feedback">Informe seu login.</div>
            </div>

            <div class="alert alert-danger py-2 text-center" style="font-size:13px;" *ngIf="errorMessage" role="alert">
              {{ errorMessage }}
            </div>

            <div class="modal-footer border-0 px-0 pb-0 pt-2">
              <button type="button" class="btn btn-light flex-fill" (click)="close()">Cancelar</button>
              <button type="submit" class="btn btn-entrar flex-fill" [disabled]="isLoading">
                <span *ngIf="!isLoading">Enviar</span>
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>

          </form>
        </div>

        <div class="pb-4"></div>

      </ng-container>

      <!-- Confirmação -->
      <ng-container *ngIf="submitted">
        <div class="modal-body px-4 py-4 text-center">
          <div class="success-icon mx-auto mb-3">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <h5 class="fw-bold mb-2">E-mail enviado!</h5>
          <p class="text-muted mb-4" style="font-size:14px;">
            Se o login existir em nossa base, você receberá um e-mail com as instruções. Verifique também a caixa de spam.
          </p>
          <button type="button" class="btn btn-entrar w-100" (click)="close()">Entendi</button>
        </div>
      </ng-container>

    </div>
  </div>
</div>